export const GST_RATES = [0, 0.25, 3, 5, 12, 18, 28];

/**
 * Ensures user passes a supported rate.
 */
function assertRate(rate: number) {
    if (!GST_RATES.includes(rate)) {
        throw new Error(`Unsupported GST rate ${rate}. Allowed: ${GST_RATES.join(', ')}%`);
    }
}


/* @param {number} gross   Price *including* GST
 * @param {number} rate    GST rate in percent (e.g. 18)
 * @param {"intra"|"inter"} supply  intra = CGST+SGST split; inter = IGST
 */
export function inclusiveCalc(gross: number, rate: number, supply: "intra" | "inter" = "intra") {
    assertRate(rate);

    const divisor = 1 + rate / 100;
    const base = +(gross / divisor).toFixed(2);
    const tax = +(gross - base).toFixed(2);

    if (supply === "inter") {
        return { base, igst: tax, total: gross };
    }

    // intra-state => 50 % split between CGST and SGST
    const half = +(tax / 2).toFixed(2);
    return { base, cgst: half, sgst: half, total: gross };
}

/* @param {number} base    Price *excluding* GST
 * @param {number} rate    GST rate in percent (e.g. 18)
 * @param {"intra"|"inter"} supply  intra = CGST+SGST split; inter = IGST
 */
export function exclusiveCalc(base: number, rate: number, supply: "intra" | "inter" = "intra") {
    assertRate(rate);

    const tax = +(base * rate / 100).toFixed(2);
    const gross = +(base + tax).toFixed(2);

    if (supply === "inter") {
        return { base, igst: tax, total: gross };
    }

    // intra-state => 50 % split between CGST and SGST
    const half = +(tax / 2).toFixed(2);
    return { base, cgst: half, sgst: half, total: gross };
}
